import { EMPTY_EFFECTIVE_ACCESS_CONTROL, EffectiveAccessControl } from "../models/role-feature.models";

export const hasFeatureAccess = (
  accessControl: EffectiveAccessControl | null | undefined,
  featureKey: string,
): boolean => {
  if (!featureKey) {
    return false;
  }

  const effectiveAccess = accessControl ?? EMPTY_EFFECTIVE_ACCESS_CONTROL;
  return effectiveAccess.permissions[featureKey] === true || effectiveAccess.grantedFeatures.includes(featureKey);
};

export const hasAnyFeatureAccess = (
  accessControl: EffectiveAccessControl | null | undefined,
  featureKeys: readonly string[],
): boolean => featureKeys.some((featureKey) => hasFeatureAccess(accessControl, featureKey));

